import { render, staticRenderFns } from "./section-report-bottom.vue?vue&type=template&id=0e22e789&scoped=true"
import script from "./section-report-bottom.vue?vue&type=script&lang=js"
export * from "./section-report-bottom.vue?vue&type=script&lang=js"
import style0 from "./section-report-bottom.vue?vue&type=style&index=0&id=0e22e789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22e789",
  null
  
)

export default component.exports